import { initReactI18next } from 'react-i18next';
import i18n, { use } from 'i18next';
import detector from 'i18next-browser-languagedetector';

import { StorageKey, StorageService, TLocaleCode } from '@treezor/design-system';

import translationDE from '@/assets/locales/de.json';
import translationEN from '@/assets/locales/en.json';
import translationFR from '@/assets/locales/fr.json';
import translationES from '@/assets/locales/es.json';
import { TPartialRecord, TRequiredByKeys } from '@/globals';

export const DashboardLanguage = {
  enGB: 'enGB',
  fr: 'fr',
  es: 'es',
  de: 'de',
} as const;

export type TDashboardLanguage = keyof typeof DashboardLanguage;

export const defaultLanguage = DashboardLanguage.enGB;

const userLang = StorageService?.get(StorageKey.LANGUAGE) || defaultLanguage;

// the translations
export const resources: TRequiredByKeys<
  TPartialRecord<
    TLocaleCode,
    { translation: typeof translationEN | typeof translationFR | typeof translationDE | typeof translationES }
  >,
  typeof defaultLanguage
> = {
  enGB: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  de: {
    translation: translationDE,
  },
  es: {
    translation: translationES,
  },
};

use(initReactI18next) // Pass i18n down to react-i18next
  .use(detector) // uses browser storage to store current and changing language
  .init({
    lng: userLang, //overrides detector to set i18n language, not using storage
    fallbackLng: defaultLanguage, // Use enGB if detected lng is not available
    resources,
    returnNull: false,
    returnEmptyString: false,
    debug: false,
  });

export default i18n;
